import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import {makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { CircularProgress } from '@material-ui/core';

import {getHexWithOpacity} from 'lib/util';
import QualifiedServiceIcon from 'components/QualifiedServiceIcon';


const useStyles = makeStyles(theme => ({
  title : {
    fontSize: '13px',
    color: theme.palette.common.battleshipGrey,
  },
  selectorContainer: {
    display: 'flex',
    columnGap: '12px',
    rowGap: '12px',
    flexWrap: 'wrap',
    marginTop: '12px',
  },
  selector: {
    height: '60px',
    flexGrow: '1',
    background: `${getHexWithOpacity(theme.palette.secondary.main, 5)}`,
    border: '1px solid',
    borderColor: `${getHexWithOpacity(theme.palette.secondary.main, 15)}`,
    borderRadius: '8px',
    padding: '8px 16px 8px 12px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',

    '&:hover' : {
      background: `${getHexWithOpacity(theme.palette.secondary.main, 10)}`
    },
    '&:active' : {
      background: `${getHexWithOpacity(theme.palette.secondary.main, 15)}`
    },
  },
  selectorDisabled: {
    cursor: 'not-allowed',
    '&:hover' : {
      background: `${getHexWithOpacity(theme.palette.secondary.main, 5)}`,
    },
  },
  iconContainer : {
    marginRight: '15px',
  },
  text: {
    fontSize: '13px',
    fontWeight: '500',
    color: theme.palette.secondary.dark,
  },
  loader: {
    color: theme.palette.secondary.main,
  },
}));

const ServiceSelection = ({ title, data, onSelect, className='' }) => {
  const classes = useStyles();

  const onClick = item => {
    if (!item)
      return;

    const data = {
      id: item.id,
      name: item.name,
      qualifiedServiceCategory: item?.qualifiedServiceCategory
    };

    onSelect(data);
  };

  return (
    <div className={className}>
      <Typography variant="subtitle2" className={classes.title}>{title}</Typography>
      <div className={classes.selectorContainer}>
        {data.map((item, index) => (
          <div
            className={item ? classes.selector : classNames(classes.selector, classes.selectorDisabled)}
            key={`selector-${index}`}
            onClick={() => onClick(item)}
          >
            {item ? (
              <>
                <div className={classes.iconContainer}>
                  <QualifiedServiceIcon.Circle serviceName={item?.name}/>
                </div>
                <div className={classes.text}>{item?.name}</div>
              </>) : <CircularProgress className={classes.loader} size={25} />}
          </div>
        ))}
      </div>
    </div>
  );
};

ServiceSelection.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  onSelect: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default ServiceSelection;